<template>
  <div class="logo-wrapper" @click="toDashboard()">
    <img
      :class="isCircleLogo ? 'logo-img circle-logo' : 'logo-img'"
      :src="logo"
      v-if="logo"
    />
    <div v-else class="logo">
      <span>{{ $t('text.logo').toUpperCase() }}</span>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    logo() {
      if (this.$store.state.customization.logo) {
        return this.$store.state.customization.logo
      }
      return null
    },
    isCircleLogo() {
      return !!this.$store.state.customization.isCircleLogo
    }
  },
  methods: {
    toDashboard() {
      this.$router.push('/')
    }
  }
}
</script>
